import ActionTypes from './Types';

export const changePage = (index) => ({
    type: ActionTypes.CHANGE_PAGE,
    payload: index
  })


